export type CameraBounds = {
    north: number;
    south: number;
    east: number;
    west: number;
};

export type AzureCameraBounds = [number, number, number, number];

function isFiniteNumber(value: any): value is number {
    return typeof value === 'number' && Number.isFinite(value);
}

function isValidBounds(bounds: CameraBounds): boolean {
    return isFiniteNumber(bounds.west)
        && isFiniteNumber(bounds.south)
        && isFiniteNumber(bounds.east)
        && isFiniteNumber(bounds.north)
        && bounds.west <= bounds.east
        && bounds.south <= bounds.north;
}

function toAzureCameraBounds(bounds: CameraBounds): AzureCameraBounds | null {
    if (!isValidBounds(bounds)) {
        return null;
    }

    return [
        bounds.west,
        bounds.south,
        bounds.east,
        bounds.north,
    ];
}

function toBoundsFromLocationRect(rect: any): CameraBounds | null {
    if (!rect) return null;
    if (isFiniteNumber(rect.north) && isFiniteNumber(rect.south) && isFiniteNumber(rect.east) && isFiniteNumber(rect.west)) {
        return {
            north: rect.north,
            south: rect.south,
            east: rect.east,
            west: rect.west,
        };
    }
    if (rect.center && isFiniteNumber(rect.center.latitude) && isFiniteNumber(rect.center.longitude)) {
        const height = isFiniteNumber(rect.height) ? rect.height : 0;
        const width = isFiniteNumber(rect.width) ? rect.width : 0;
        const halfHeight = height / 2;
        const halfWidth = width / 2;
        return {
            north: rect.center.latitude + halfHeight,
            south: rect.center.latitude - halfHeight,
            east: rect.center.longitude + halfWidth,
            west: rect.center.longitude - halfWidth,
        };
    }
    return null;
}

export function normalizeCameraBounds(bounds: any): AzureCameraBounds | null {
    if (!bounds) {
        return null;
    }

    if (Array.isArray(bounds)) {
        if (bounds.length === 4 && bounds.every(isFiniteNumber)) {
            const [west, south, east, north] = bounds;
            return toAzureCameraBounds({ west, south, east, north });
        }

        if (bounds.length === 2 && Array.isArray(bounds[0]) && Array.isArray(bounds[1])) {
            const [[west, south], [east, north]] = bounds;
            return toAzureCameraBounds({ west, south, east, north });
        }
    }

    const rectBounds = toBoundsFromLocationRect(bounds);
    return rectBounds ? toAzureCameraBounds(rectBounds) : null;
}
